import { Link } from "react-router-dom";
import { Footer } from "../components/Footer";

export function NotFoundPage() {
  return (
    <div className="flex min-h-full flex-col">
      <div className="flex flex-1 items-center justify-center p-4">
        <div className="glass rounded-2xl px-10 py-9 text-center shadow-glass">
          <p className="text-4xl font-semibold tabular-nums text-zinc-400">404</p>
          <p className="mt-2 text-sm text-zinc-600">This page does not exist.</p>
          <Link
            to="/"
            className="mt-3 inline-block text-[13px] font-medium text-zinc-800 underline decoration-zinc-400 underline-offset-2 transition-colors hover:decoration-zinc-900"
          >
            Back to the overview
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
